
import { useEffect, useState } from 'react'

import { Link } from 'react-router-dom';
import axios from 'axios';
import { ProjectConfig } from 'Global';


import ic_santoral from 'icons/ic_santoral.svg';
import ic_liturgia_horas from 'icons/ic_liturgia_horas.svg';
import ic_misas from 'icons/ic_misas.svg';
import ic_celebraciones from 'icons/ic_celebraciones.svg';
import ic_aniversarios from 'icons/ic_aniversarios.svg';
import ic_ano_liturgico from 'icons/ic_ano_liturgico.svg';
import ic_oraciones from 'icons/ic_oraciones.svg';
import ic_multimedia from 'icons/ic_multimedia.svg';
import ic_maximas from 'icons/ic_maximas.svg';
import ic_fiestasmovibles from 'icons/ic_fiestasmovibles.svg';

import ic_constituciones from 'icons/ic_constituciones.svg';
import ic_directorio from 'icons/ic_directorio.svg';
import ic_acuerdos_capitulares from 'icons/ic_acuerdos_capitulares.svg';
import SantoralList from 'components/Santoral/SantoralList';
import CalendarioList from 'components/Calendario/CalendarioList';
import AniversariosList from 'components/Aniversarios/AniversariosList';
import AnoLiturgicoViewer from 'components/AnoLiturgico/AnoLiturgicoViewer';
import AnoLiturgicoCategories from 'components/AnoLiturgico/AnoLiturgicoCategories';
import { getHomeLabel } from 'hooks/useLabels';

// Fallback icons map
const fallbackIcons: Record<string, string> = {
  'santoral': ic_santoral,
  'liturgia_horas': ic_liturgia_horas,
  'misas': ic_misas,
  'fiestas': ic_fiestasmovibles,
  'ano_liturgico': ic_ano_liturgico,
  'oraciones': ic_oraciones,
  'rituales': ic_oraciones,
  'celebraciones': ic_celebraciones,
  'aniversarios': ic_aniversarios,
  'maximas': ic_maximas,
  'multimedia': ic_multimedia,
  'constituciones': ic_constituciones,
  'directorio': ic_directorio,
  'acuerdos_capitulares': ic_acuerdos_capitulares,
};

// Route mapping for each module
const moduleRoutes: Record<string, string> = {
  'santoral': '/santoral',
  'liturgia_horas': '/liturgia-horas?user_id=10',
  'misas': '/misas',
  'fiestas': '/fiestas',
  'ano_liturgico': '/ano-liturgico',
  'oraciones': '/oraciones',
  'rituales': '/ritos',
  'celebraciones': '/celebraciones',
  'aniversarios': '/aniversarios',
  'maximas': '/maximas',
  'multimedia': '/multimedia',
  'constituciones': '/constituciones',
  'directorio': '/Directorio',
  'acuerdos_capitulares': '/acuerdos-capitulares',
};

// Label mapping for each module (for getHomeLabel)
const moduleLabelKeys: Record<string, string> = {
  'santoral': 'santoral',
  'liturgia_horas': 'liturgia_horas',
  'misas': 'misa_del_dia',
  'fiestas': 'propios',
  'ano_liturgico': 'calendario_liturgico',
  'oraciones': 'oraciones',
  'rituales': 'ritos',
  'celebraciones': 'celebraciones',
  'aniversarios': 'aniversarios',
  'maximas': 'maximas',
  'multimedia': 'multimedia',
  'constituciones': 'constituciones',
  'directorio': 'directorio',
  'acuerdos_capitulares': 'acuerdos_capitulares',
};

export default function Home (props: any) {

  const [homeIcons, setHomeIcons] = useState<Record<string, any>>({});
  const [sortedIcons, setSortedIcons] = useState<any[]>([]);
  const [iconsLoaded, setIconsLoaded] = useState(false);

  useEffect(() => {
    props.setLoading(false);
    
    // Load home icons from API
    axios.get(ProjectConfig.api_url, {
      params: {
        request: 'home_icons_app'
      }
    })
    .then((response) => {
      if (response.data.success && response.data.icons) {
        // Convert array to object keyed by module_key
        const iconsMap: Record<string, any> = {};
        response.data.icons.forEach((icon: any) => {
          iconsMap[icon.module_key] = icon;
        });
        setHomeIcons(iconsMap);
        
        // Sort icons by orden field
        const sorted = [...response.data.icons].sort((a, b) => a.orden - b.orden);
        setSortedIcons(sorted);
      }
      setIconsLoaded(true);
    })
    .catch((err) => {
      console.log('Error loading home icons:', err);
      setIconsLoaded(true);
    });
  }, []);
  
  // Fecha activa del Home: viene desde CalendarBar.
  // CalendarBar actualiza localStorage.date y el estado global fechaView.
  const today = new Date();
  const todayFormatted = [
    today.getFullYear(),
    String(today.getMonth() + 1).padStart(2, '0'),
    String(today.getDate()).padStart(2, '0')
  ].join('-');

  const homeDate = props.fechaView || localStorage.getItem('date') || todayFormatted;

  // Helper function to get icon image URL
  const getIconImage = (moduleKey: string) => {
    const icon = homeIcons[moduleKey];
    if (icon && icon.image) {
      return `${ProjectConfig.api_url.replace('/api/', '/')}/files/home_icons/${icon.image}`;
    }
    return fallbackIcons[moduleKey] || ic_oraciones; // Use fallback or default
  };

  // Helper function to get icon background color
  const getIconBgColor = (moduleKey: string) => {
    const icon = homeIcons[moduleKey];
    return icon?.bg_color || '#BF7A1C';
  };
 
  // console.log("props.setFechaView")
  // console.log(props.setFechaView)
  
  return (
    <div id='Home' className='module_container'>
      <div className="module_topBar">
        
      </div>
      
      <SantoralList key={`santoral-${homeDate}`} setLoading={props.setLoading} inHome={true} fixedDate={homeDate} scope="general_roman"/>
      
      <div className='module_content'>
        <div id='iconsContainer'>
          {sortedIcons.map((iconData) => {
            const moduleKey = iconData.module_key;
            const route = moduleRoutes[moduleKey] || '/';
            const labelKey = moduleLabelKeys[moduleKey] || moduleKey;
            
            // Special handler for ano_liturgico
            const handleClick = moduleKey === 'ano_liturgico'
              ? () => {
                  localStorage.setItem('date', "null");
                  props.setLoading(true);
                }
              : moduleKey === 'santoral'
                ? () => props.setLoading(false)
                : () => props.setLoading(true);

            return (
              <Link 
                key={moduleKey}
                to={route} 
                className='icon' 
                onClick={handleClick}
              >
                <div 
                  id={`ic_${moduleKey}`} 
                  className='iconImage' 
                  style={{ backgroundColor: getIconBgColor(moduleKey) }}
                >
                  <img
                    src={fallbackIcons[moduleKey] || ic_oraciones}
                    alt={moduleKey}
                  />
                  {iconData.image && (
                    <img
                      src={getIconImage(moduleKey)}
                      alt=""
                      aria-hidden="true"
                      style={{
                        position: 'absolute',
                        inset: 0,
                        width: '100%',
                        height: '100%',
                        objectFit: 'contain'
                      }}
                      onError={(event) => {
                        event.currentTarget.style.display = 'none';
                      }}
                    />
                  )}
                </div>
                <h3>{getHomeLabel(labelKey)}</h3>
              </Link>
            );
          })}
          
          {/* Empty placeholders for grid alignment */}
          <Link to='#' className='icon' style={{ visibility: 'hidden' }}></Link>
          <Link to='#' className='icon' style={{ visibility: 'hidden' }}></Link>
          <Link to='#' className='icon' style={{ visibility: 'hidden' }}></Link>
        </div>
      </div>

      <AniversariosList key={`aniversarios-${homeDate}`} setLoading={props.setLoading} inHome={true} fixedDate={homeDate}/>
    
        
    </div>
  );
};


